import { render } from "./pageEdit.vue?vue&type=template&id=31a09dac&scoped=true"
import script from "./pageEdit.vue?vue&type=script&lang=js"
export * from "./pageEdit.vue?vue&type=script&lang=js"

import "./pageEdit.vue?vue&type=style&index=0&id=31a09dac&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a09dac"],['__file',"src/views/page/components/pageEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31a09dac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31a09dac', __exports__)) {
    console.log('reload')
    api.reload('31a09dac', __exports__)
  }
  
  module.hot.accept("./pageEdit.vue?vue&type=template&id=31a09dac&scoped=true", () => {
    console.log('re-render')
    api.rerender('31a09dac', render)
  })

}


export default __exports__